import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import api from '../../lib/api';

/**
 * Opens the OFFICIAL DOLE NSRP Reg Form 2 PDF, filled with the employer's establishment
 * registration data (the backend draws the answers onto the real form). PESO staff click
 * "Print Form 2" → this loads the filled PDF and auto-opens the print dialog (one click).
 * Signature/date are left blank for handwriting. Office-scoped on the backend.
 */
const PesoNsrp2Print = () => {
  const { employerId } = useParams();
  const navigate = useNavigate();
  const [url, setUrl] = useState('');
  const [err, setErr] = useState('');
  const iframeRef = useRef(null);
  const printedRef = useRef(false);

  const load = useCallback(async () => {
    try {
      const { data: s } = await supabase.auth.getSession();
      const res = await api.get(`/api/peso/employer/${employerId}/nsrp2.pdf`, {
        headers: { Authorization: `Bearer ${s?.session?.access_token}` },
        responseType: 'blob',
      });
      setUrl(URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })));
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Could not load this establishment’s form.');
    }
  }, [employerId]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  // One-click: auto-open the print dialog once the PDF is rendered in the iframe.
  const onFrameLoad = () => {
    if (printedRef.current) return;
    printedRef.current = true;
    setTimeout(() => {
      try { iframeRef.current?.contentWindow?.print(); } catch (e) { /* worker can use the Print button */ }
    }, 600);
  };

  const printNow = () => {
    try { iframeRef.current?.contentWindow?.print(); } catch (e) { if (url) window.open(url, '_blank'); }
  };

  if (err) {
    return (
      <div style={{ padding: 40, fontFamily: 'sans-serif' }}>
        <p>{err}</p>
        <button onClick={() => navigate('/peso')}>Back to dashboard</button>
      </div>
    );
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#525659' }}>
      <div style={{ background: '#1d4ed8', color: '#fff', padding: '8px 14px', display: 'flex', gap: 10, alignItems: 'center' }} className="no-print">
        <button onClick={printNow} style={{ background: '#fff', color: '#1d4ed8', border: 0, padding: '6px 12px', borderRadius: 6, fontWeight: 600, cursor: 'pointer' }}>🖨 Print</button>
        <button onClick={() => navigate('/peso')} style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)', padding: '6px 12px', borderRadius: 6, cursor: 'pointer' }}>← Back</button>
        <span style={{ fontSize: 12, opacity: 0.9 }}>Official NSRP Reg Form 2 — filled. The print dialog opens automatically.</span>
      </div>
      {url ? (
        <iframe
          ref={iframeRef}
          title="NSRP Form 2"
          src={url}
          onLoad={onFrameLoad}
          style={{ flex: 1, width: '100%', border: 0 }}
        />
      ) : (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontFamily: 'sans-serif' }}>Loading the official NSRP Form 2…</div>
      )}
    </div>
  );
};

export default PesoNsrp2Print;
